import { useGetNotificationsQuery, useReadNotificationMutation } from '@metadevprofile/shared/api';
import { useEffect, useMemo } from 'react';
import { getEdenErrorMessage } from '@/common/lib/get-eden-error';
import { notificationService } from '@/common/lib/notification-service';

export function useNotifications() {
  const { data, isLoading, error } = useGetNotificationsQuery({ limit: 50, page: 0 });
  const [readNotificationMutation] = useReadNotificationMutation();

  useEffect(() => {
    if (error) {
      notificationService.error(getEdenErrorMessage(error, 'notification:errors.loadNotificationsFailed'));
    }
  }, [error]);

  const notifications = data ?? [];
  const unreadCount = useMemo(
    () => notifications.filter((notification) => !notification.read_at).length,
    [notifications],
  );

  const markAsRead = async (notificationId: string) => {
    try {
      await readNotificationMutation({ notification_id: notificationId }).unwrap();
    } catch (mutationError) {
      notificationService.error(getEdenErrorMessage(mutationError, 'notification:errors.markAsReadFailed'));
    }
  };

  const markAllAsRead = async () => {
    const unreadNotifications = notifications.filter((notification) => !notification.read_at);
    try {
      await Promise.all(
        unreadNotifications.map((notification) =>
          readNotificationMutation({ notification_id: notification.id }).unwrap(),
        ),
      );
    } catch (mutationError) {
      notificationService.error(getEdenErrorMessage(mutationError, 'notification:errors.markAsReadFailed'));
    }
  };

  return { notifications, unreadCount, isLoading, markAsRead, markAllAsRead };
}
